import router from "./index"
import store from "@/store/index"
import { Message } from "element-ui"
import { getCookie } from "@/unit/cookie"
import NProgress from 'nprogress' //进度条
import 'nprogress/nprogress.css' //进度条样式


const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (!!window.sessionStorage.getItem('token')) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (!store.getters.roles) {
        store.dispatch('GetInfo', getCookie("username")).then(res => { //
          let menus = res.data.data
          store.dispatch('GenerateRoutes', menus).then(() => { //
            // let accessRoutes = store.getters.addRouters
            // for (let i = 0; i < accessRoutes.length; i++) {
            //   const element = accessRoutes[i]
            //   router.addRoute(element)
            // }
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
            next({ ...to, replace: true })
          })
        }).catch(err => {
          window.sessionStorage.clear()
          Message.error(err || 'Verification failed, please login again')
          next({ path: '/' })
        })
      } else {
        next()
      }
    }
  } else {
    // 未登录 页面是否需要登录
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next({ path: '/login' })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})